module.exports = __webpack_public_path__ + "static/media/digital-work2.cd02b1b0.jpg";